exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ni[data-v-3f5e58bf] {\n    cursor: pointer;\n    color: #e74444;\n    font-size: 0.7em;\n}\n", ""]);

// exports
